import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import {
  fetchPropertyById,
  fetchProperties,
  fetchPropertyCommonAreas,
  fetchPropertyCounts,
  clearCountsDone,
} from '../../store/actions/properties';
import { CSVLink } from 'react-csv';
import { getPropertyBuildings } from '../../store/actions/buildings';
import { PATHS } from '../../common/constants';
import { selectPropertyById } from '../../store/selectors/properties';
import {
  setPropertyFormData,
  clearPropertyFormData,
} from '../../store/actions/propertyForm';
import Avatar from '../../components/Avatar';
import Breadcrumb from '../../components/Breadcrumb';
import Button from '../../components/Button';
import Card from '../../components/Card';
import HeadingWithDetails from '../../components/HeadingWithDetails';
import Icon from '../../components/Icon';
import Loader from '../../components/Loader';
import Metrics from '../../components/Metrics';
import Overlay from '../../components/Overlay';
import PropertyDocuments from './PropertyDocuments';
import PropertyForm from '../../components/PropertyForm';
import PropertyNotes from './PropertyNotes';
import PropertyServiceRequests from './PropertyServiceRequests';
import PropertySuites from './PropertySuites';
import PropertyCommonAreas from './PropertyCommonAreas';
import PropertyDevelopers from './PropertyDevelopers';
import Empty from '../../components/Empty';
import Tabs from '../../components/Tabs';
import Tenant from '../../components/Tenant';
import WithNavigation from '../../layouts/WithNavigation';
import {
  fetchFaqsNotesDocuments,
  clearNotes,
} from '../../store/actions/faqsNotesDocuments';
import {
  selectNotes,
  selectDocuments,
} from '../../store/selectors/faqsNotesDocuments';
import { selectSuites } from '../../store/selectors/suites';
import { upload } from '../../helpers/upLoadHelper';
import { updateProperty, deleteProperty } from '../../store/actions/properties';
import {
  selectAuthenticatedUser,
  selectpropertyManagerDetails,
} from '../../store/selectors/auth';
import { selectServiceRequests } from '../../store/selectors/serviceRequests';
import {
  fetchServiceRequestByPropertyIdUserIdRole,
  clearServiceRequests,
} from '../../store/actions/serviceRequests';
import { getWalkthroughSuites } from '../../store/actions/WalkthroughSuites';
import { selectPropertyCommonAreas } from '../../store/selectors/propertyCommonAreas';
import { selectCounts } from '../../store/selectors/Counts';
import { Colors, variables } from '../../Tenants';
import { checkSparkDataAvailable } from '../../helpers/validationHelper';
import { getSuiteOnBoardingConveyanceFormListByPropertyCSV } from '../../store/actions/Property';
import { onRequestPhoneCall } from '../../helpers/validationHelper';
import {
  fetchtAllowedTabList,
  setSelectedModulePermission,
} from '../../store/actions/tabSelections';
import { clearActiveSuiteTab } from '../../store/actions/activeTab';
import { startFormLoading, stopFormLoading } from '../../store/actions/loader';
import { BrandingContext } from '../../branding/BrandingContextProvider';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
import 'react-image-lightbox/style.css';

let headers = [
  { label: 'Law Firm Notary', key: 'lawFirmNotary' },
  {
    label: 'Legal Representative Contact Name',
    key: 'lawyerNotaryContactName',
  },
  { label: 'Legal Representative Mailing Address', key: 'mailingAddress' },
  { label: 'Legal Representative Phone', key: 'phone' },
  { label: 'Legal Representative Email', key: 'email' },
  { label: 'Legal Representative Fax', key: 'fax' },
  { label: 'Financial Institution Bank', key: 'financialInstitutionBank' },
  { label: 'Property Name', key: 'propertyName' },
  { label: 'Suite Name', key: 'suiteName' },
  { label: 'Strata Lot', key: 'stratalot' },
  { label: 'Home Owner', key: 'homeOwner' },
  { label: 'Date', key: 'dateTime' },
];

class Property extends Component {
  state = {
    showOverlay: false,
    isOpen: false,
    count: true,
  };

  async componentDidMount() {
    const {
      onFetchFaqsNotesDocuments,
      property,
      user,
      getWalkthroughSuites,
      clearServiceRequests,
      onFetchPropertyCounts,
      clearCountsDone,
      getPropertyBuildings,
      fetchtAllowedTabList,
      clearNotes,
    } = this.props;
    clearNotes();
    await onFetchFaqsNotesDocuments(property.propertyId);
    clearCountsDone();
    fetchtAllowedTabList(property.propertyId);
    onFetchPropertyCounts(
      property.propertyId,
      user.id,
      user.roles[0].role.name
    );
    this.downloadConveyanceFormList();
    clearServiceRequests();
    if (property && property.propertyId) {
      getWalkthroughSuites(property.propertyId);
    }
    getPropertyBuildings(property.propertyId);
  }
  componentWillUnmount() {
    const { clearActiveSuiteTab } = this.props;
    clearActiveSuiteTab();
  }
  onSaveProperty = async (data) => {
    let params = {};

    let imageUrl = null;
    if (data.selectedImage && data.selectedImage.length > 0) {
      imageUrl = await upload(data.selectedImage[0]);
    }

    let stages =
      data.constructionStages && data.constructionStages.length > 0
        ? data.constructionStages.filter((cs) => !cs.new)
        : [];

    if (data.propertyId) {
      params = {
        id: data.propertyId,
        propertyId: data.propertyId,
        name: data.name,
        addressLine1: data.addressLine1,
        addressLine2: '',
        city: data.city,
        province: data.province,
        postalCode: data.postalCode,
        latitude: '17.5896',
        longitude: '17.556896',
        image: imageUrl != null ? imageUrl : data.image,
        UserId: this.props.user.id,
        PropertyManagerId:
          data.propertyManager && data.propertyManager.id
            ? data.propertyManager.id
            : data.propertyManagerId,
        StrataManagerId: data.strataManagerId
          ? data.strataManagerId
          : data.strataManager && data.strataManager.id
            ? data.strataManager.id
            : null,
        ConstructionStages: stages,
        modulePermissions: data.modulePermissions || [],
      };

      this.props.onUpdateProperty(params);
    }
  };

  deleteProperty(data) {
    this.props.onDeleteProperty(
      data.id,
      this.props.user.id,
      this.props.history
    );
  }
  homeOwnerCount() {
    let suites = this.props.suites;
    let count = [];
    let user = suites.map((u) =>
      count.includes(u.homeownerId) ? null : count.push(u.homeownerId)
    );
    return count.length;
  }
  downloadConveyanceFormList = () => {
    const { property, getSuiteOnBoardingConveyanceFormListByPropertyCSV } =
      this.props;
    getSuiteOnBoardingConveyanceFormListByPropertyCSV(property.propertyId);
  };

  onSetPropertFormDataCall(data) {
    const { onSetPropertyFromData, setSelectedModulePermission } = this.props;
    onSetPropertyFromData(data);
    let ModulePermissions = [];
    if (data.modulePermissions !== null) {
      ModulePermissions = data.modulePermissions.map((item) => {
        return { Id: item.id };
      });
    }
    setSelectedModulePermission(ModulePermissions);
  }
  static contextType = BrandingContext;
  render() {
    const {
      onClearPropertyFormData,
      property,
      user,
      counts,
      tabList,
      notesList,
    } = this.props;
    var HmeOwnrOcpntRltrNotes = [];
    var noteVisibleToHomeownerOccupantRealtor = false;
    const { branding } = this.context;
    if (
      notesList !== undefined &&
      notesList != null &&
      notesList !== '' &&
      notesList.length > 0
    ) {
      let notes = notesList.filter((x) => x.type == 'NOTES');
      if (notes.length > 0) {
        notes.forEach((object) => {
          HmeOwnrOcpntRltrNotes.push(
            JSON.parse(JSON.parse(JSON.stringify(object.data)))
          );
        });
      }
      if (HmeOwnrOcpntRltrNotes.length > 0) {
        let filterNotes = HmeOwnrOcpntRltrNotes.filter(
          (x) => x.noteVisibleToHomeownerOccupantRealtor == true
        );
        if (filterNotes.length > 0) {
          noteVisibleToHomeownerOccupantRealtor = true;
        }
      }
    }

    JSON.stringify();
    const serviceRequestId =
      this.props.location.state &&
      this.props.location.state.data.serviceRequestId
        ? this.props.location.state.data.serviceRequestId
        : null;
    let homeOwnerCheck =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      user.roles[0].role.name === 'Home Owner'
        ? true
        : false;
    let { isOpen } = this.state;
    const { showOverlay } = this.state;
    let linkView = false;
    if (
      user.roles[0].role.name === 'Admin' ||
      user.roles[0].role.name === 'Property Developer' ||
      user.roles[0].role.name === 'Strata Manager'
    ) {
      linkView = true;
    }

    if (property && property.id) {
      return (
        <WithNavigation
          title={property.name}
          top={
            <HeadingWithDetails
              style={{
                backgroundImage: `url(/assets/banner-property.png)`,
              }}
              breadcrumb={
                serviceRequestId !== null ? (
                  <Breadcrumb
                    to={PATHS.SERVICE_REQUESTS_VIEW.replace(
                      ':id',
                      serviceRequestId
                    )}
                    label="Service Request"
                  />
                ) : (
                  <Breadcrumb to={PATHS.PROPERTIES_LIST} label="Properties" />
                )
              }
              headline={property.name}
              items={[
                <Card
                  body={
                    <>
                      {property.addressLine1}
                      <br />
                      {property.city}, {property.province}
                      <br />
                      {property.postalCode}
                    </>
                  }
                />,
                <Metrics
                  title="Overview"
                  items={[
                    {
                      key: variables.suiteName,
                      value: counts.suitesCount ? counts.suitesCount : 0,
                    },
                    {
                      key: variables.homeOwners,
                      value: counts.homeOwnersCount
                        ? counts.homeOwnersCount
                        : 0,
                    },
                    {
                      key: branding.text.serviceRequest,
                      value: counts.serviceRequestsCount
                        ? counts.serviceRequestsCount
                        : 0,
                    },
                  ]}
                />,
                <Card
                  title={'Primary ' + variables.propertyDeveloper}
                  body={
                    property.propertyManager &&
                    property.propertyManager.firstname ? (
                      <Tenant
                        headline={
                          linkView === true ? (
                            <a
                              href={PATHS.CONTACTS_VIEW.replace(
                                ':id',
                                property.propertyManager.id
                              )}
                            >
                              {property.propertyManager.firstname}{' '}
                              {property.propertyManager.lastname}
                            </a>
                          ) : (
                            property.propertyManager.firstname +
                            '' +
                            property.propertyManager.lastname
                          )
                        }
                        strapline={''}
                        avatar={
                          <div
                            onClick={() =>
                              this.setState({
                                isOpen: property.propertyManager.profileImage
                                  ? true
                                  : false,
                              })
                            }
                          >
                            <Avatar
                              badge="property-manager"
                              url={property.propertyManager.profileImage}
                            />
                            {isOpen && isOpen === true ? (
                              <ReusableLightbox
                                isOpen={this.state.isOpen}
                                onClose={() => this.setState({ isOpen: false })}
                                image={property.propertyManager.profileImage}
                              />
                            ) : null}
                          </div>
                        }
                      />
                    ) : (
                      <div style={{ textAlign: 'center' }}>Unassigned</div>
                    )
                  }
                />,
                <Card
                  title="Strata Manager"
                  body={
                    property.strataManager &&
                    property.strataManager.firstname ? (
                      <Tenant
                        headline={
                          linkView === true ? (
                            <a
                              href={PATHS.CONTACTS_VIEW.replace(
                                ':id',
                                property.strataManager.id
                              )}
                            >
                              {property.strataManager.firstname}{' '}
                              {property.strataManager.lastname}
                            </a>
                          ) : (
                            property.strataManager.firstname +
                            ' ' +
                            property.strataManager.lastname
                          )
                        }
                        strapline={onRequestPhoneCall(
                          property.strataManager.phone
                        )}
                        avatar={
                          <div
                            onClick={() =>
                              this.setState({
                                isOpen: property.strataManager.profileImage
                                  ? true
                                  : false,
                              })
                            }
                          >
                            <Avatar
                              badge="strata-manager"
                              url={property.strataManager.profileImage}
                            />
                            {isOpen && isOpen === true ? (
                              <ReusableLightbox
                                isOpen={this.state.isOpen}
                                onClose={() => this.setState({ isOpen: false })}
                                image={property.strataManager.profileImage}
                              />
                            ) : null}
                          </div>
                        }
                      />
                    ) : (
                      <div style={{ textAlign: 'center' }}>Unassigned</div>
                    )
                  }
                />,
              ]}
              actions={
                checkSparkDataAvailable(property, user.roles[0].role.name) ||
                homeOwnerCheck ||
                user.roles[0].role.name === 'Occupant' ? null : (
                  <>
                    <Button
                      color="semantic"
                      onClick={() => {
                        this.setState({ showOverlay: true });
                        this.onSetPropertFormDataCall(property);
                      }}
                      label={<Icon glyph="pencil" weight="light" />}
                    />
                    {user.roles[0].role.name === 'Admin' ||
                    user.roles[0].role.name === 'Super Admin' ? (
                      <Button
                        color="semantic"
                        onClick={() =>
                          window.confirm(
                            `Are you sure you want to delete ${property.name}?`
                          ) && this.deleteProperty(property)
                        }
                        label={<Icon glyph="trash" weight="light" />}
                      />
                    ) : null}
                    <Overlay
                      showOverlay={showOverlay}
                      content={
                        <PropertyForm
                          onClose={() =>
                            this.setState({ showOverlay: false }, () =>
                              onClearPropertyFormData()
                            )
                          }
                          tabList={tabList}
                          onSaveProperty={(data) => this.onSaveProperty(data)}
                        />
                      }
                    />
                  </>
                )
              }
            />
          }
          bottom={
            <Tabs
              from={'Property'}
              items={[
                {
                  label: variables.suiteName,
                  count: counts.suitesCount
                    ? counts.suitesCount.toString()
                    : '0',
                  content: <PropertySuites property={property} />,
                },
                {
                  label: branding.text.serviceRequest + 's',
                  count: counts.serviceRequestsCount
                    ? counts.serviceRequestsCount.toString()
                    : '0',
                  content: <PropertyServiceRequests property={property} />,
                },
                {
                  label: 'Manuals & Documents',
                  count: counts.documentsCount
                    ? counts.documentsCount.toString()
                    : '0',
                  content: <PropertyDocuments property={property} />,
                },
                {
                  label: 'Common Areas',
                  count: counts.commonAreasCount
                    ? counts.commonAreasCount
                    : '0',
                  content: <PropertyCommonAreas property={property} />,
                },
                (homeOwnerCheck ||
                  user.roles[0].role.name === 'Occupant' ||
                  user.roles[0].role.name === 'Realtor') &&
                noteVisibleToHomeownerOccupantRealtor == false
                  ? {}
                  : {
                      label: 'Notes',
                      count: counts.notesCount
                        ? counts.notesCount.toString()
                        : '0',
                      content: <PropertyNotes property={property} />,
                    },
                homeOwnerCheck || user.roles[0].role.name === 'Occupant'
                  ? {}
                  : {
                      label: 'People',
                      count: counts.propertyDevelopersCount
                        ? counts.propertyDevelopersCount.toString()
                        : '0',
                      content: <PropertyDevelopers property={property} />,
                    },
                user &&
                (user.roles[0].role.name === 'Admin' ||
                  user.roles[0].role.name === 'Super Admin' ||
                  user.roles[0].role.name === 'Property Developer')
                  ? {
                      label: variables.conveyance,
                      content: (
                        <Empty
                          headline="Download CSV File"
                          strapline="Download a csv of the submitted legal/notary information from homeowners."
                          searchIsActive={''}
                          cta={
                            <>
                              <CSVLink
                                data={this.props.propertyCSV}
                                headers={headers}
                                filename={'Legal_Notary_Info.csv'}
                                className="button"
                                style={{
                                  backgroundColor: Colors.toggleAndButtonColor,
                                }}
                                target="_blank"
                              >
                                Download CSV File
                              </CSVLink>
                            </>
                          }
                          image={
                            <img
                              alt="No notes yet"
                              src="/assets/download_convaynance.png"
                            />
                          }
                        />
                      ),
                    }
                  : {},
              ]}
            />
          }
        />
      );
    }

    return <Loader />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    notes: selectNotes(state),
    user: selectAuthenticatedUser(state),
    propertyManagerDetails: selectpropertyManagerDetails(state),
    property: selectPropertyById(state, ownProps.match.params.id),
    suites: selectSuites(state),
    documents: selectDocuments(state),
    serviceRequests: selectServiceRequests(state),
    propertyCommonAreas: selectPropertyCommonAreas(state),
    counts: selectCounts(state),
    propertyCSV: state.Property.payload,
    tabList: state.tabSelections.tabList,
    notesList: state.notes,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
      onFetchProperties: fetchProperties,
      onFetchPropertyById: fetchPropertyById,
      onSetPropertyFromData: setPropertyFormData,
      onClearPropertyFormData: clearPropertyFormData,
      fetchServiceRequestByPropertyIdUserIdRole:
        fetchServiceRequestByPropertyIdUserIdRole,
      onUpdateProperty: updateProperty,
      onDeleteProperty: deleteProperty,
      clearServiceRequests,
      getWalkthroughSuites,
      onFetchPropertyCommonAreas: fetchPropertyCommonAreas,
      onFetchPropertyCounts: fetchPropertyCounts,
      clearCountsDone: clearCountsDone,
      getPropertyBuildings: getPropertyBuildings,
      getSuiteOnBoardingConveyanceFormListByPropertyCSV:
        getSuiteOnBoardingConveyanceFormListByPropertyCSV,
      setSelectedModulePermission,
      fetchtAllowedTabList,
      clearActiveSuiteTab,
      clearNotes,
      startFormLoading,
      stopFormLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Property);
